export default {"src":"/planning/bridesmaid-dress/quiz/_next/static/media/logo-pearl.6bf24797.svg","height":3000,"width":7200};